import { useState } from 'react'
import { isOnServer } from '@shared/constants/util'
import { setGlobalContextFromRoute } from '@/features/shared/utils/appStart/setGlobalContextFromRoute'
import { type PageRouteData } from '@/features/shared/utils/setPageProps'
import { type RouteName } from '@shared/constants/routes'

export const useSetRouteViewName = (routeData: PageRouteData) => {
  const [trackedName, setTrackedName] = useState<RouteName | null>(null)

  // this is fine to call on render since it is just setting the global context for DD
  if (!isOnServer() && routeData && routeData.routeName !== trackedName) {
    setTrackedName(routeData.routeName)
    setGlobalContextFromRoute(routeData)
  }
}
